import React from 'react';

import Player from '../functions/player';
import API from '../functions/api';

export class Leaderboard extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      timerOver: false,
    };
  }

  request = async () => {
    const response = await API.post('/?action=getLeaderboard');
    const json = await response;

    this.setState = ({
      element: json.data,
    });
    let scores = [];
    for (let index = 0; index < json.data.length; index++) {
      scores.push(
        <p>element.name</p>
      );
    }

    return scores;
  }

  renderScores = () => {
    let local = this;

    API.post('/?action=getLeaderboard')
      .then(function (response) {
        local.setState({
          element: response.data,
        });
      })
    .catch(function (error) {
      console.log(error);
    });

  }

  convertToVisual = () => {
    let state = this.state.element;
    let scores = [];

    for (let i = 0; i < state.length; i++) {
      const element = state[i];
      const date = new Date(element.updatedAt);

      scores.push(
        <tr key={'row_score' + i} >
          <td key={'data__place' + i} >{ i+1}</td>
          <td key={'data__name' + i} >{element.className}</td>
          <td key={'data__score' + i} >{element.score}</td>
          <td key={'data__necessities' + i} >{element.necessities} MWU</td>
          <td key={'data__mwuGreen' + i} >{element.mwuGreen} MWU</td>
          <td key={'data__updatedAt' + i} >{date.getDate()}-{date.getMonth() + 1}-{date.getFullYear()}</td>
        </tr>
      );
    }
    return scores;
  }

  componentWillMount = () => {
    var currentLocation = this.props.location.pathname;
    Player.storeData('localRoute', currentLocation);

    this.renderScores();
    document.body.classList.add('body-leaderbord');
    var root = document.getElementsByTagName( 'html' )[0]; // '0' to assign the first (and only `HTML` tag)
    root.setAttribute( 'class', 'body-leaderbord' );
  }

  render(){
    return(
      <div className="leaderboards">
        <table className="leaderboard_table">
          <thead>
            <tr>
              <th>Plaats</th>
              <th>Klas</th>
              <th>Score</th>
              <th>Voorziening</th>
              <th>Groene stroom</th>
              <th>Datum</th>
            </tr>
          </thead>
          <tbody>
          { this.state.element && this.convertToVisual() }
          { !this.state.element && <tr><td colSpan='6'><img className="loading_icon"alt='Loading' src={require("../assets/elements/spinner.svg")}/></td></tr> }
          </tbody>
        </table>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/leaderboard.js